/* eslint-disable react/no-array-index-key */
import React from 'react';
import cn from 'classnames';
import {
  Icon,
  Row,
  Col,
  Input,
  Button,
  Tabs,
  message,
  Drawer,
  AutoComplete,
  Dropdown,
  Menu,
} from 'antd';
import qs from 'query-string';
import antdCss from 'antd/dist/antd.css';
import ReactSVG from 'react-svg';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import LeftLinks from './Custom/Ncov/LeftLinks';
import NcovRightLinks from './Custom/Ncov/RightLinks';
import Customized1RightLinks from './Custom/Customized1/RightLinks';
import Customized2RightLinks from './Custom/Customized2/RightLinks';
import Customized3RightLinks from './Custom/Customized3/RightLinks';
import { debounce, backendErrorTip } from '../../utils';
import xfetch from '../../xfetch';
import s from './Robot.css';

const { TabPane } = Tabs;
const { Option: AcOption } = AutoComplete;
const { Item: MenuItem } = Menu;

class Robot extends React.Component {
  state = {
    asks: [],
    answers: [],
    askDisabled: false,
    hotQuestions: [],
    leftQuestions: [],
    rightQuestions: [],
    maxHeight: 'none',
    settings: {},
    acDataSource: [],
    acValue: '',
    drawerVisible: false,
    hostQuestionCategories: [],
    ups: [],
    downs: [],
  };

  componentDidMount() {
    this.getSettings();
    window.onresize = this.fitView;
    const y = 0;
    const x = 1000;
    let rand = parseInt(Math.random() * (x - y + 1) + y, 10);
    const randLocal = localStorage.getItem('rand');
    if (randLocal) {
      rand = randLocal;
    } else {
      localStorage.setItem('rand', rand);
    }
    this.setState({
      rand,
    });
  }

  getOrganization = () => qs.parse(window.location.search).organization || '';

  getHotQuestions = async theme => {
    const { error, result } = await xfetch(
      `${
        window.G.backendApi
      }/knowledge/question/hot/?page=1&page_size=60&organization=${this.getOrganization()}`,
    );
    if (error) {
      backendErrorTip(error);
      return;
    }
    const hotQuestions = result.results;
    const hostQuestionCategories = hotQuestions
      .map(x => x.answer_knowledge_category_title)
      .filter((v, i, a) => a.indexOf(v) === i && v);

    let rightQuestionCount;
    switch (theme) {
      case 'ncov':
        rightQuestionCount = 3;
        break;
      case 'customized1':
        rightQuestionCount = 8;
        break;
      case 'customized2':
        rightQuestionCount = 5;
        break;
      default:
        break;
    }
    this.setState({
      hotQuestions,
      hostQuestionCategories,
      leftQuestions: hotQuestions
        .filter(x => x.answer_hot_place === 'left_top')
        .slice(0, this.batchSize),
      rightQuestions: hotQuestions
        .filter(x => x.answer_hot_place === 'right_top')
        .slice(0, rightQuestionCount),
    });
  };

  getSettings = async () => {
    const { error, result } = await xfetch(
      `${
        window.G.backendApi
      }/system/settings/?organization=${this.getOrganization()}`,
    );
    if (error) {
      backendErrorTip(error);
      return;
    }
    const settings = result.length ? result[0] : {};

    this.setState(
      {
        settings,
      },
      () => {
        document.title = settings.title;
        document.querySelector('input').focus();
        this.getHotQuestions(settings.theme);
        setTimeout(this.fitView, 200);
      },
    );
  };

  batch = 0;
  batchSize = 6;

  showDrawer = drawerVisible => {
    this.setState({
      drawerVisible,
    });
  };

  fitView = () => {
    const view = document.getElementById('js-wrap');
    if (!view) {
      return;
    }
    const viewH = view.offsetHeight;
    const header = document.getElementById('js-header');
    const footer = document.getElementById('js-footer');
    const headerH = header ? header.offsetHeight : 0;
    const footerH = footer ? footer.offsetHeight : 0;
    this.setState({
      maxHeight: viewH - headerH - footerH - 20,
    });
  };

  checkSuggestion = (suggestion, index) => {
    const {
      settings: { best_answer_score: robotThreshold, im_scripts = [] },
      ups,
      downs,
    } = this.state;
    const sugg = suggestion[0];
    const imScripts = im_scripts
      .map(({ name, value }) => {
        const div = document.createElement('div');
        div.style.display = 'none';
        div.innerHTML = value;
        const link = div.querySelector('a');
        return {
          name,
          value: link ? link.href : '',
        };
      })
      .filter(x => x.value);

    if (!sugg) {
      return [
        <div className={s.answerTip} style={{ margin: 0 }}>
          没有找到答案，请重新输入
        </div>,
      ];
    }

    const match = suggestion.find(x => x.score > robotThreshold);

    if (sugg.score > robotThreshold) {
      return [
        <div
          key="2"
          dangerouslySetInnerHTML={{ __html: sugg.answer_content }}
        />,
        <div key="3" className={s.likebox}>
          <span
            onClick={() => this.upOrDown(sugg.answer_id, 'up', index)}
            className={`up-span up-${index}`}
          >
            <Icon type="like" /> 满意
          </span>
          <span
            onClick={() => this.upOrDown(sugg.answer_id, 'down', index)}
            className={`down-span down-${index}`}
          >
            <Icon type="dislike" /> 不满意
          </span>
          {imScripts.length > 0 ? (
            <span>
              <Dropdown
                overlay={
                  <Menu>
                    {imScripts.map(({ name, value }) => (
                      <MenuItem key="1">
                        <a target="blank" href={value}>
                          <Icon type="user" /> {name}
                        </a>
                      </MenuItem>
                    ))}
                  </Menu>
                }
              >
                <span>
                  <Icon type="message" />
                  人工服务
                </span>
              </Dropdown>
            </span>
          ) : null}
        </div>,
        <div key="4" className={s.answerTip}>
          关联问题推荐：
        </div>,
        ...suggestion
          .slice(1)
          .map(x => (
            <div
              className={s.relativeQs}
              onClick={() => this.send(x.question_title)}
              key={x.id}
              dangerouslySetInnerHTML={{ __html: x.question_title }}
            />
          )),
      ];
    } else if (match) {
      return [
        <div key="1" className={s.answerTip}>
          <span className={s.likebox}>
            <span
              onClick={() => this.upOrDown(sugg.id, 'up', index)}
              className={`up-span up-${index}`}
            >
              <Icon type="like" /> 满意
            </span>
            <span
              onClick={() => this.upOrDown(sugg.id, 'down', index)}
              className={`down-span down-${index}`}
            >
              <Icon type="dislike" /> 不满意
            </span>
          </span>
          {imScripts.length > 0 ? (
            <span>
              <Dropdown
                overlay={
                  <Menu>
                    {imScripts.map(({ name, value }) => (
                      <MenuItem key="1">
                        <a target="blank" href={value}>
                          <Icon type="user" /> {name}
                        </a>
                      </MenuItem>
                    ))}
                  </Menu>
                }
              >
                <span>
                  <Icon type="message" />
                  人工服务
                </span>
              </Dropdown>
            </span>
          ) : null}
        </div>,
        <div
          key="2"
          dangerouslySetInnerHTML={{ __html: match.answer_content }}
        />,
        <div key="2" className={s.answerTip}>
          关联问题推荐：
        </div>,
        ...suggestion
          .filter(x => x.score < robotThreshold)
          .map(x => (
            <div
              className={s.relativeQs}
              key={x.id}
              onClick={() => this.send(x.question_title)}
              dangerouslySetInnerHTML={{ __html: x.question_title }}
            />
          )),
      ];
    }

    return [
      <div key="1" className={s.answerTip}>
        关联问题推荐：
      </div>,
      ...suggestion.map(x => (
        <div
          className={s.relativeQs}
          key={x.id}
          onClick={() => this.send(x.question_title)}
          dangerouslySetInnerHTML={{ __html: x.question_title }}
        />
      )),
    ];
  };

  send = async input => {
    const { asks, answers, askDisabled } = this.state;
    if (!input || askDisabled) {
      return;
    }
    const oldAnswers = [...answers];

    const api = `${
      window.G.backendApi
    }/knowledge/robot/dialogue/?msg=${input}&organization=${this.getOrganization()}`;

    this.setState(
      {
        askDisabled: true,
        drawerVisible: false,
        asks: [...asks, input],
        answers: [...oldAnswers, [<Icon type="loading" />]],
      },
      () => {
        setTimeout(() => {
          this.scrollBottom();
        }, 100);
      },
    );

    const { error, result } = await xfetch(api);
    this.setState({
      askDisabled: false,
      acValue: '',
    });
    if (error) {
      backendErrorTip();
      this.setState(
        {
          answers: [
            ...oldAnswers,
            [<div>额...机器人出现了一点问题，稍后再试。</div>],
          ],
        },
        this.scrollBottom,
      );
      return;
    }
    const { suggestion = [] } = result;

    this.setState(
      {
        answers: [
          ...oldAnswers,
          this.checkSuggestion(suggestion, oldAnswers.length + 1),
        ],
      },
      this.scrollBottom,
    );
  };

  scrollBottom = () => {
    const view = document.getElementById('js-robot-view');
    view.scrollTop = view.scrollHeight;
  };

  upOrDown = async (id, type, index) => {
    const { ups, downs } = this.state;

    // 已经点赞了
    if (type === 'up' && ups.includes(index)) {
      return;
    }

    // 已经点踩
    if (type === 'down' && downs.includes(index)) {
      return;
    }
    let set = {};

    if (type === 'up') {
      set = {
        ups: [...ups, index],
      };

      if (downs.includes(index)) {
        set.downs = downs.filter(x => x !== index);
      }
    }

    if (type === 'down') {
      set = {
        downs: [...downs, index],
      };

      if (ups.includes(index)) {
        set.ups = ups.filter(x => x !== index);
      }
    }

    this.setState(set, () => {
      [...document.querySelectorAll('.up-span,.down-span')].forEach(x => {
        x.style.color = null;
      });
      this.state.ups.forEach(x => {
        document.querySelector(`.up-${x}`).style.color = '#1890ff';
      });
      this.state.downs.forEach(x => {
        document.querySelector(`.down-${x}`).style.color = '#1890ff';
      });
    });

    const { error } = await xfetch(
      `${
        window.G.backendApi
      }/knowledge/robot/${id}/${type}/?organization=${this.getOrganization()}`,
    );
    if (error) {
      message.error('反馈失败');
      return;
    }
    message.success('谢谢反馈');
  };

  handleAcSearch = async value => {
    if (!value) {
      this.setState({
        acDataSource: [],
      });
      return;
    }

    const { error, result } = await xfetch(
      `${
        window.G.backendApi
      }/knowledge/question/suggest/?search_str=${value}&organization=${this.getOrganization()}`,
    );
    if (error) {
      backendErrorTip(error);
      return;
    }
    this.setState({
      acDataSource: result.map(x => (
        <AcOption key={x} value={x} title={x}>
          {x}
        </AcOption>
      )),
    });
  };

  changeBatch = () => {
    const totalHotQuestions = this.state.hotQuestions.filter(
      x => x.answer_hot_place === 'left_top',
    );
    const maxBatch = Math.ceil(totalHotQuestions.length / this.batchSize);
    if (this.batch + 1 >= maxBatch) {
      this.batch = 0;
      this.setState({
        leftQuestions: totalHotQuestions.slice(this.batch, this.batchSize),
      });
    } else {
      this.batch += 1;
      const nextBatch = this.batch + 1;
      this.setState({
        leftQuestions: totalHotQuestions.slice(
          this.batchSize * this.batch,
          this.batchSize * nextBatch,
        ),
      });
    }
  };

  render() {
    const {
      asks,
      answers,
      maxHeight,
      hotQuestions,
      settings,
      acValue,
      acDataSource,
      drawerVisible,
      leftQuestions,
      rightQuestions,
      rand,
      hostQuestionCategories,
    } = this.state;
    if (!Object.keys(settings).length) {
      return null;
    }
    const enableH5 =
      settings.enabled_model && settings.enabled_model.indexOf('h5') !== -1;
    let askAvatar = <img src="/assets/images/user.png" alt="" width="32" />;

    if (['customized2'].includes(settings.theme)) {
      askAvatar = (
        <img
          src="/assets/images/icon/cd-tfxq/ask-avatar.png"
          alt=""
          width="40"
        />
      );
    }

    if (['customized3'].includes(settings.theme)) {
      askAvatar = null;
    }

    let sendBtn = (
      <Button
        type="primary"
        className={cn(s.sendBtn, s[`sbtn-${settings.theme}`])}
        onClick={() => this.send(acValue)}
      >
        <ReactSVG
          src="/assets/images/send.svg"
          svgStyle={{ width: 16, height: 16 }}
        />
        发送
      </Button>
    );

    if (['customized2'].includes(settings.theme)) {
      sendBtn = (
        <Button
          ghost
          type="primary"
          className={cn(s.sendBtn, s[`sbtn-${settings.theme}`])}
          onClick={() => this.send(acValue)}
        >
          发送
          <Icon type="caret-down" />
        </Button>
      );
    }

    if (['customized3'].includes(settings.theme)) {
      sendBtn = (
        <Button
          type="primary"
          className={cn(s.sendBtn, s[`sbtn-${settings.theme}`])}
          onClick={() => this.send(acValue)}
        >
          发送
        </Button>
      );
    }

    return (
      <div
        className={cn(
          s.wrap,
          s[`theme-wrap-${settings.theme}`],
          enableH5 && s.h5box,
        )}
        id="js-wrap"
      >
        {['blue', 'orange', 'green', 'narrow'].includes(settings.theme) && (
          <div className={cn(s.header, 'clearfix')} id="js-header">
            <div className={s.brand}>
              <span>
                <span>{settings.title}</span>
              </span>
            </div>
            <div className={s.menuIcon} onClick={() => this.showDrawer(true)}>
              <Icon type="menu" />
            </div>
          </div>
        )}
        {['customized3'].includes(settings.theme) && (
          <div className={cn(s.header, 'clearfix')} id="js-header">
            <div className={s.brand}>
              <img src="/assets/images/icon/haishi/logo.svg" alt="" />
            </div>
            <div className={s.helpTip}>航小问为您解决问题</div>
          </div>
        )}
        {['customized2'].includes(settings.theme) && (
          <div className={cn(s.header, 'clearfix')} id="js-header">
            <div className={s.brand}>
              <span>
                <img src="/assets/images/icon/cd-tfxq/logo.png" alt="" />
              </span>
            </div>
            <div className={s.login}>
              <img src="/assets/images/icon/cd-tfxq/user_head.png" alt="" />
              游客_{rand}
            </div>
          </div>
        )}
        <div className={s.body}>
          <Row type="flex" gutter="0" className={s.bodyRow}>
            <Col
              sm={['customized1'].includes(settings.theme) ? 15 : 16}
              xs={
                enableH5
                  ? 24
                  : ['customized1'].includes(settings.theme)
                  ? 15
                  : 16
              }
              className={s.dialog}
            >
              <div className={s.dialogBox}>
                <div
                  className={s.msgBox}
                  style={{ height: maxHeight, maxHeight }}
                  id="js-robot-view"
                >
                  <div className={s.msgList}>
                    <div className={s.qsBox}>
                      <div className={cn(s.answer, 'clearfix')}>
                        <div className={s.robot_avatar}>
                          <img src={settings.robot_avatar} alt="" width="32" />
                        </div>
                        <div className={cn(s.answerBox, s.msg)}>
                          {settings.hello_word}
                        </div>
                      </div>
                    </div>
                    {['customized1', 'ncov', 'customized3'].includes(
                      settings.theme,
                    ) && (
                      <LeftLinks
                        data={leftQuestions}
                        changeBatch={this.changeBatch}
                        handleClickQuestion={this.send}
                        theme={settings.theme}
                        s={s}
                      />
                    )}
                    {asks.map((ask, i) => (
                      <div className={s.qsBox}>
                        <div className={s.ask}>
                          {askAvatar}
                          <div className={cn(s.askBox, s.msg)}>{ask}</div>
                        </div>
                        <div className={cn(s.answer, 'clearfix')}>
                          <div className={s.robot_avatar}>
                            <img
                              src={settings.robot_avatar}
                              alt=""
                              width="32"
                            />
                          </div>
                          <div className={cn(s.answerBox, s.msg)}>
                            {answers[i] &&
                              answers[i].map((answer, j) => (
                                <div key={`${i}-${j}`}>{answer}</div>
                              ))}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className={s.sendBox} id="js-footer">
                  <div
                    className={cn(
                      s.sendInput,
                      s[`sendInput-${settings.theme}`],
                    )}
                  >
                    <AutoComplete
                      autoFocus={!!1}
                      size="large"
                      className={s.acSearch}
                      value={acValue || ''}
                      onSearch={debounce(this.handleAcSearch)}
                      onChange={v => this.setState({ acValue: v })}
                      optionLabelProp="title"
                      onSelect={v => {
                        setTimeout(() => {
                          this.setState({
                            acValue: '',
                          });
                        });
                        this.send(v);
                      }}
                      on
                      dataSource={acDataSource}
                    >
                      <Input
                        value={acValue}
                        placeholder={
                          ['customized3'].includes(settings.theme)
                            ? '请输入您想咨询的内容'
                            : '请输入你想问的问题...'
                        }
                        onKeyUp={e => {
                          if (e.keyCode === 13) {
                            this.send(acValue);
                          }
                        }}
                      />
                    </AutoComplete>
                  </div>
                  <div className={s.sendBar}>{sendBtn}</div>
                </div>
              </div>
            </Col>
            <Col
              sm={['customized1'].includes(settings.theme) ? 9 : 8}
              xs={enableH5 ? 0 : 8}
              className={s.service}
            >
              {/* <div className={s.svTitle}>
                <Icon type="search" />
                便民查询
              </div>
              <div className={s.svCon}>
                <Tag color="magenta">住房公积金</Tag>
                <Tag color="red">社保</Tag>
                <Tag color="volcano">户口迁移</Tag>
                <Tag color="orange">医疗保险</Tag>
                <Tag color="gold">每日资讯</Tag>
                <Tag color="lime">成都新政</Tag>
                <Tag color="green">交通交规</Tag>
                <Tag color="cyan">学前教育</Tag>
                <Tag color="blue">个人所得税</Tag>
                <Tag color="geekblue">补贴政策</Tag>
                <Tag color="purple">创业扶持</Tag>
              </div> */}
              <div className={cn(s.news, s[`tabs-${settings.theme}`])}>
                {['blue', 'orange', 'green', 'narrow'].includes(
                  settings.theme,
                ) && (
                  <Tabs defaultActiveKey="1" animated={false}>
                    <TabPane tab="热点问题" key="1">
                      <div
                        className={cn(s.hotQs, s[`hotQs-${settings.theme}`])}
                      >
                        {hotQuestions.map(x => (
                          <div key={x.id} onClick={() => this.send(x.title)}>
                            {x.title}
                          </div>
                        ))}
                      </div>
                    </TabPane>
                    {hostQuestionCategories.map(cat => (
                      <TabPane tab={cat} key={cat}>
                        <div
                          className={cn(s.hotQs, s[`hotQs-${settings.theme}`])}
                        >
                          {hotQuestions
                            .filter(
                              x => x.answer_knowledge_category_title === cat,
                            )
                            .map(x => (
                              <div
                                key={x.id}
                                onClick={() => this.send(x.title)}
                              >
                                {x.title}
                              </div>
                            ))}
                        </div>
                      </TabPane>
                    ))}
                  </Tabs>
                )}
                {['ncov'].includes(settings.theme) && (
                  <NcovRightLinks
                    s={s}
                    data={rightQuestions}
                    handleClickQuestion={this.send}
                  />
                )}
                {['customized1'].includes(settings.theme) && (
                  <Customized1RightLinks
                    s={s}
                    data={rightQuestions}
                    handleClickQuestion={this.send}
                  />
                )}
                {['customized2'].includes(settings.theme) && (
                  <Customized2RightLinks
                    s={s}
                    data={rightQuestions}
                    handleClickQuestion={this.send}
                  />
                )}
                {['customized3'].includes(settings.theme) && (
                  <Customized3RightLinks
                    s={s}
                    data={rightQuestions}
                    handleClickQuestion={this.send}
                  />
                )}
              </div>
            </Col>
          </Row>
          <Drawer
            title="热点问题"
            placement="right"
            width="100%"
            closable
            onClose={() => this.showDrawer(false)}
            visible={drawerVisible}
            className={s.drawer}
          >
            {['blue', 'orange', 'green', 'narrow'].includes(settings.theme) && (
              <div className={cn(s.hotQs, s[`hotQs-${settings.theme}`])}>
                {hotQuestions.map(x => (
                  <div key={x.id} onClick={() => this.send(x.title)}>
                    {x.title}
                  </div>
                ))}
              </div>
            )}
            {['ncov'].includes(settings.theme) && (
              <div className={s[`theme-wrap-${settings.theme}`]}>
                <NcovRightLinks
                  s={s}
                  data={rightQuestions}
                  handleClickQuestion={this.send}
                />
              </div>
            )}
            {['customized1'].includes(settings.theme) && (
              <div className={s[`theme-wrap-${settings.theme}`]}>
                <Customized1RightLinks
                  s={s}
                  data={rightQuestions}
                  handleClickQuestion={this.send}
                />
              </div>
            )}
            {['customized2'].includes(settings.theme) && (
              <div className={s[`theme-wrap-${settings.theme}`]}>
                <Customized2RightLinks
                  s={s}
                  data={rightQuestions}
                  handleClickQuestion={this.send}
                />
              </div>
            )}
          </Drawer>
        </div>
        {['customized2'].includes(settings.theme) && (
          <div className={s.footer} />
        )}
      </div>
    );
  }
}

export default withStyles(antdCss, s)(Robot);
